import React from 'react';
import { connect } from 'react-redux';
import * as actions from 'store/actions/index';
import * as DataUtil from 'Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil';
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import './CustomFlexListBox.scss';
import * as CustomTable from 'Flow2/components/CustomCollections/CustomBox/CustomTableBox/CustomTableBox';
import MediaFile from 'Flow2/util/MediaFile';
import { injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretUp, faCaretDown, faCog, faSort } from "@fortawesome/free-solid-svg-icons";

class CustomFlexListBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    onItemClick = (item) => () => {
        let sorted = this.props.customFlexAppConfig.listBoxSorted;
        if (sorted && sorted.includes(DataUtil.DESC)) sorted = sorted.replace(DataUtil.DESC, DataUtil.ASC);
        else sorted = item[0].sorted;
        this.props.getCustomFlexAppConfig({ listBoxSorted: sorted });
    }

    onPublishedClick = (item) => () => {
        let published = this.props.customFlexAppConfig.listBoxPublished;
        this.props.getCustomFlexAppConfig({ listBoxPublished: !published });
    }

    showListHeader = ({ data }) => {
        let columnPercent = this.calculateColumn({ data });
        if (DataUtil.isFrancetv()) {
            if (data && data.length > 0 && columnPercent) {
                let thumbnail = this.props.intl.formatMessage({ id: "metadata.clip.thumbnail" });
                let actions = this.props.intl.formatMessage({ id: "metadata.clip.actions" });
                return (
                    <div className="FlexListHeader">
                        <div style={{ height: "60px" }} className="FlexListRow">
                            <div style={{ "--percentage": `${CustomTypes.CUSTOM_MEDIA_PERCENT}` }} className="MediaContainer FsMd">{thumbnail}</div>
                            {
                                data.map((item, index) => {
                                    if (index === 0) return (
                                        <div style={{ "--percentage": `${CustomTypes.CUSTOM_TITLE_PERCENT}` }} className="FlexListColumn FsMd" >
                                            <CustomTable.CustomTableHeaderIcon dataId="title" />
                                            {this.props.intl.formatMessage({ id: `${item.intl}DurationSize` })}
                                        </div>)
                                    else return (
                                        <div style={{ "--percentage": `${columnPercent}%` }} className="FlexListColumn">
                                            <div>{this.props.intl.formatMessage({ id: `${item.intl}` })}</div>
                                        </div>)
                                })
                            }
                            {/* <div style={{ "--percentage": `${CustomTypes.CUSTOM_ACTIONS_PERCENT}` }} className="FlexListColumn FsMd">{actions} </div>*/}
                        </div>
                    </div>
                );
            }
        }
        return (
            <CustomTable.CustomClipsTableHeader
                lg={this.props.lg} data={CustomTable.getHeaderDataForTable(this.props.isArticleView)}
                onPublishedClick={this.onPublishedClick}
                onItemClick={this.onItemClick} />)
    }

    changeFormat = (data) => {
        let regex = /^\d{2,4}[-:.]\d{1,2}[-:.]\d{1,2}/ig;
        if (data && data.length < 20 && data.match(regex)) {
            const { dateFormat } = this.props.uiConfig;
            return DataUtil.changeDateFormat({ data, dateFormat, isShort: true });
        }
        return data;
    }

    getMoreInfo = () => {
        if (this.props.listName === CustomTypes.CUSTOM_VIEWLIST)
            return (
                <p className="Grayed" >
                    {(typeof this.props.clip.mainmediafile !== 'undefined' && this.props.clip.mainmediafile !== null && this.props.clip.mediaType === 'video') ?
                        this.props.clip.mainmediafile.getDuration() + ' - ' : null}
                    {(typeof this.props.clip.mainmediafile !== 'undefined' && this.props.clip.mainmediafile !== null) ?
                        MediaFile.formatBytes(this.props.clip.mainmediafile.getFilesize()) : null}
                </p>
            );
        return (<div></div>);
    }

    addRowClasses = () => {
        let tmpClass = "FlexListRow";
        if (this.props.multiSelected) tmpClass += " MultiSelected";
        if (this.props.selected) tmpClass += " Selected"

        return tmpClass;
    }

    calculateColumn = ({ data, otherPercent, count }) => {
        let len = count ? count : data.length;
        let other = otherPercent ? otherPercent : 0;
        if (len) {
            if (this.props.listName === CustomTypes.CUSTOM_VIEWLIST)
                return ((100 - parseInt(CustomTypes.CUSTOM_TITLE_PERCENT) - parseInt(CustomTypes.CUSTOM_MEDIA_PERCENT)) / len).toFixed(2);
            if (this.props.listName === CustomTypes.CUSTOM_MFLIST)
                return ((100 - parseInt(CustomTypes.CUSTOM_MEDIA_PERCENT) - parseInt(other)) / len).toFixed(2);
        }
        return null;
    }

    showListContent = ({ data }) => {
        if (data && data.length > 0) {
            let tmpClass = this.addRowClasses();
            let columnPercent = this.calculateColumn({ data });
            return (<div className={tmpClass} onClick={this.props.onClick} onMouseDown={this.props.onMouseDown}
                onDoubleClick={this.props.onDoubleClick} draggable={this.props.draggable} onDragStart={this.props.onDragStart} >
                <div style={{ "--percentage": `${CustomTypes.CUSTOM_MEDIA_PERCENT}` }} className="MediaContainer">
                    {this.addOtherContent({ less: 2 })}
                </div>
                {
                    data.map((item, index) => {
                        return (
                            <div style={(index === 0) ? { "--percentage": `${CustomTypes.CUSTOM_TITLE_PERCENT}` } : { "--percentage": `${columnPercent}%` }}
                                className="FlexListColumn PoRe FsSm">
                                <CustomTable.CustomTableLargeTitle data={this.changeFormat(this.props.metadata[item.field])} />
                                {(index === 0) ? this.getMoreInfo() : null}
                            </div>)

                    })
                }
                {/* <div style={{ "--percentage": `${CustomTypes.CUSTOM_ACTIONS_PERCENT}` }} className="FlexListColumn">
                    {this.addOtherContent({ greater: 2 })}
                </div>*/}
            </div>)
        }
    }

    addMfClass = () => {
        let tmpClass = "FlexMfListRow FsSt";
        if (this.props.isOdd) tmpClass += " BgWhite FsSt";
        if (this.props.isSource) tmpClass += " Source";
        return tmpClass;
    }

    addOtherContent = ({ less, greater }) => {
        return React.Children.map(this.props.children, (child, i) => {
            if (greater) {
                if (i >= greater) return child;
                return;
            }
            if (less) {
                if (i < less) return child;
                return;
            }
        })
    }

    getNoColumns = (data) => {
        let count;
        if (this.props.children)
            count = this.props.children.length || 1;
        if (data && data.length > 0)
            count += data.length;
        return count;
    }

    isVisible = (item) => {
        if (DataUtil.isFrancetv()) {
            let mediaFormat = this.props.filename;
            mediaFormat = mediaFormat.slice(-4);
            if ((item.field === "tags" && (mediaFormat.includes("jpg") || mediaFormat.includes("png") || mediaFormat.includes("jpeg"))) || (item.field !== "tags")) return true;
            return false;
        }
        return true;
    }

    checkField = (data, columnPercent) => {
        return data.map((item) => {
            return (<div style={{ "--percentage": `${columnPercent}%` }} className="FlexListColumn FsSt">
                {this.isVisible(item) ? this.props.getOutput(this.props.mfId, item.field) : null}
            </div>)
        })
    }

    getMfHeaderDataForApp = (data) => {
        let newData;
        newData = [{ name: "type", intl: "customdata.type" }];
        if (DataUtil.isFrancetv()) newData = [...newData, ...data];
        else if (DataUtil.isVifogra()) newData.push({ name: "id", intl: "customdata.fileid" })
        else {
            newData.push(
                { name: "id", intl: "customdata.fileid" },
                { name: "language", intl: "customdata.language" },
                { name: "subtitle", intl: "customdata.subtitle" })
        }
        newData = newData.filter(item => item.field !== "info");
        newData.push({ name: "resolution", intl: "customdata.resolution" },
            { name: "filesize", intl: "customdata.filesize" },
            { name: "aspectratio", intl: "customdata.aspectratio" },
            { name: "format", intl: "customdata.format" });

        if (!DataUtil.isFrancetv()) {
            newData.push({ name: "purpose", intl: "customdata.purpose" })
        }
        return newData;
    }

    showMfHeader = ({ data }) => {
        let newData = this.getMfHeaderDataForApp(data);
        //let columnPercent = this.calculateColumn({ count: this.getNoColumns(newData) });
        let columnPercent = 100 / this.props.dColumns.length;
        if (this.props.uiConfig && this.props.uiConfig.showFlexColumns
            && this.props.uiConfig.showFlexColumns.length > 0) {
            newData = newData.filter(item => this.props.uiConfig.showFlexColumns.indexOf(item.name) > -1)
        }
        if (newData && newData.length > 0 && columnPercent) {
            return (
                <div className="FlexListHeader">
                    <div className="FlexMfListRow" >
                        {
                            newData.map((item) => {
                                let sortName = item.name.toLowerCase();
                                return (
                                    <div style={{ "--percentage": `${columnPercent}%` }} className="FlexListColumn FsMd">
                                        <div className="GroupSt">
                                            <div className="Light">{this.props.intl.formatMessage({ id: `${item.intl}` })} </div>
                                            {(sortName === "id" || sortName === "language" || sortName === "filesize" || sortName === "subtitle")
                                                ? <div className="Rounded Tn GroupCt" onClick={() => this.props.onSortClick(sortName)}>
                                                    <FontAwesomeIcon className="SortIcon" icon={faSort} /></div> : <div />}
                                        </div>
                                    </div>)
                            })
                        }
                        <div style={{ "--percentage": `${columnPercent}%`, minWidth: "220px", display: "flex", justifyContent: "flex-end" }}>
                            {this.props.children}
                        </div>
                    </div>
                </div>
            );
        }
        return (<div>{this.props.children}</div>)
    }

    showMfContent = ({ data }) => {
        if (data && data.length > 0) {
            let newData = data.filter(item => (item.field !== "info" && item.field !== "id"));
            if (!DataUtil.isFrancetv()) newData = newData.filter(item => (item.field !== "purpose" && item.field !== "tags"));
            if (this.props.uiConfig && this.props.uiConfig.showFlexColumns
                && this.props.uiConfig.showFlexColumns.length > 0) {
                newData = newData.filter(item => this.props.uiConfig.showFlexColumns.indexOf(item.name) > -1);
            }
            let columnPercent = this.calculateColumn({ count: this.getNoColumns(newData) });
            return (
                <div className={this.addMfClass()} style={{ "--percentage": `${columnPercent}%` }}>
                    {this.addOtherContent({ less: 2 })}
                    {this.checkField(newData, columnPercent)}
                    {this.addOtherContent({ greater: 2 })}
                </div>
            );
        }
        return (<div>{this.props.children}</div>)
    }

    showPageContent = () => {
        let boxparams = [{ id: 1, name: "username", label: "Username", style: "MinWdLg" },
        { id: 2, name: "username", intl: "page.admin.nameFirstname", style: "MinWdLg" },
        { id: 3, name: "role", label: "Level", style: "" },
        { id: 4, name: "created_by", label: "Created", style: "" },
        { id: 5, name: "lastactivity", intl: "page.admin.lastActivity", style: "MinWdMd" },
        { id: 6, name: "", label: "", style: "MinWdMd" }];
        return (
            <div>
                <div className="OtherContent">{this.addOtherContent({ less: 1 })}</div>
                <div className="ContentColumn">
                    <div className="ContentRow BgWhite BxSd MgBtSm">
                        {boxparams.map(item => <div className={`FlexColumn GroupSt Hv PdLSm ${item.style}`} onClick={() => this.props.toggleOrder(item.name)}>
                            <div>{item.intl ? this.props.intl.formatMessage({ id: item.intl }) : item.label}</div>
                            {item.name ? <div className="MgLTn"><FontAwesomeIcon style={{ color: "#d5001c" }} icon={faCaretDown} />
                                <FontAwesomeIcon style={{ color: "#d5001c" }} icon={faCaretUp} />
                            </div> : <div />}
                        </div>)}
                    </div>
                    {this.addOtherContent({ greater: 1 })}
                </div>
            </div>);
    }

    showPageTabs = () => {
        if (DataUtil.isFrancetv()) {
            return (
                <div>
                    <div className="OtherPageTabs">
                        <span><FontAwesomeIcon icon={faCog} /></span>
                        {this.addOtherContent({ less: 2 })}
                    </div>
                    {this.addOtherContent({ greater: 2 })}
                </div>
            )
        }
        return this.props.children;
    }

    render() {
        if (this.props.listName) {
            let data = this.props.customFlexAppConfig[this.props.listName];
            if (this.props.listName === CustomTypes.CUSTOM_MFLIST) {
                return this.props.isHeader ? this.showMfHeader({ data }) : this.showMfContent({ data });
            }
            if (this.props.listName === CustomTypes.CUSTOM_VIEWLIST) {
                return this.props.isHeader ? this.showListHeader({ data, isArticleView: this.props.isArticleView }) : this.showListContent({ data });
            }
            if (this.props.listName === CustomTypes.CUSTOM_ADMINPAGE) {
                return this.showPageContent();
            }
            if (this.props.listName === CustomTypes.CUSTOM_ADMINTABS) {
                return this.showPageTabs();
            }
        }
        return (<div>{this.props.children}</div>)
    }
}

const mapStateToProps = (state) => ({
    customFlexAppConfig: state.customData.customFlexAppConfig,
    uiConfig: state.customData.customUiConfigForApp,
    lg: state.ui.language
});

const mapDispatchToProps = (dispatch) => ({
    getCustomFlexAppConfig: (option) => dispatch(actions.getCustomFlexAppConfig(option))
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CustomFlexListBox));
